import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { pickStationBrandIds } from '../../../lib/utils';
import { fetchBrands } from '../../actions/brands';
import GenericStationListItem from './GenericStationListItem';

function mapStateToProps({ brands, fuels, badgeAds }, ownProps) {
  const { station } = ownProps;
  const availableBrands = pickStationBrandIds(station)
    .map(brandId => brands.brandsById[brandId])
    .filter(branding => !!(branding && branding.image_url));

  return {
    brands: availableBrands,
    hasBadgeAds: !!Object.keys(badgeAds.byId),
    isFetchingFuels: !!fuels.isFetchingStation[station.id],
    ratings: {
      ratingCount: station && station.ratings_count,
      starValue: station && station.star_rating,
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchBrands(brandIds) {
      dispatch(fetchBrands(brandIds));
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GenericStationListItem));
